const initialState = {
  onboardingStep: 0
};

export const defaultReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_ONBOARDING_STEP':
      return Object.assign({}, state, {
        onboardingStep: action.step
      });
    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/store/reducers/index.js